import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import lenis from "@/lib/smooth";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import Branding from "@/pages/Branding";
import Marketing from "@/pages/Marketing";
import ForBusinesses from "@/pages/ForBusinesses";
import LiveProduction from "@/pages/LiveProduction";
import Systems from "@/pages/Systems";
import S3Films from "@/pages/S3Films";
import About from "@/pages/About";
import StartProject from "@/pages/StartProject";
import Legal from "@/pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<Work />} />
            <Route path="/branding" element={<Branding />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/for-businesses" element={<ForBusinesses />} />
            <Route path="/live-production" element={<LiveProduction />} />
            <Route path="/s3-films" element={<S3Films />} />
            <Route path="/systems" element={<Systems />} />
            <Route path="/about" element={<About />} />
            <Route path="/start-a-project" element={<StartProject />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <div className="grain-overlay" />
      </BrowserRouter>
    </div>
  );
}

export default App;
